import React from "react";
import PropTypes from "prop-types";
import Table from "../../common/Table";
import { Button } from "react-bootstrap";
import { faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";

const ResultsTable = ({ results, locale, onClick, onEdit, onDelete }) => (
  <Table
    striped
    hover
    columns={[
      {
        name: "name",
        labelKey: "indicator.management.result",
        customBodyRenderer: (activeElement) => (
          <Button variant="link" onClick={() => onClick(activeElement)}>
            {activeElement.name[locale]}
          </Button>
        )
      },
      {
        name: "actionField",
        labelKey: "indicator.management.action.field.or.fields",
        customBodyRenderer: (result) => {
          return result.actionFields ? result.actionFields.map((af) => af.name[locale]).join(", ") : "";
        }
      },
      {
        name: "management",
        labelKey: "app.common.title.actions",
        className: "actions",
        actions: [
          {
            code: "edit",
            labelKey: "app.common.action.edit",
            icon: faPencilAlt,
            onClick: (activeElement) => onEdit(activeElement)
          },
          {
            code: "delete",
            labelKey: "app.common.action.delete",
            className: "text-danger",
            icon: faTrash,
            onClick: (activeElement) => {
              onDelete(activeElement.id);
            }
          }
        ]
      }
    ]}
    data={results}
  />
);

ResultsTable.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object),
  locale: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};

export default ResultsTable;
